import { Modal } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ModalContainer = styled.div`
  display: block;
`;

export interface ConfirmCampaignLiveModalProps {
  open: boolean;
  onClose: () => void;
  onExitButtonClicked: () => void;
}

export const ConfirmCampaignLiveModal = ({ open, onClose, onExitButtonClicked }: ConfirmCampaignLiveModalProps) => {
  const { t } = useTranslation('campaigns');
  return (
    <Modal
      minWidth={570}
      heading={t('onsite.editor.workflow.confirmCampaignLiveModal.heading')}
      isOpen={open}
      variation="clean"
      onCloseButtonClicked={onClose}
      // We need to swap the confirm/cancel as we want the primary button to be on the left hand side
      // of the modal
      onCancelButtonClicked={onExitButtonClicked}
      onOkButtonClicked={onClose}
      okButtonLabel={t('onsite.editor.workflow.confirmCampaignLiveModal.closeButton')}
      okButtonAriaLabel={t('onsite.editor.workflow.confirmCampaignLiveModal.closeButton')}
      okButtonType={'secondary'}
      cancelButtonType={'primary'}
      cancelButtonLabel={t('onsite.editor.workflow.confirmCampaignLiveModal.confirmButton')}
      cancelButtonAriaLabel={t('onsite.editor.workflow.confirmCampaignLiveModal.confirmButton')}
    >
      <ModalContainer>
        <div>{t('onsite.editor.workflow.confirmCampaignLiveModal.body')}</div>
      </ModalContainer>
    </Modal>
  );
};
